
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ExportModuleSyncInfo} from './ExportModuleSyncInfo';
import {FieldModelExportModuleSyncInfo} from './ExportModuleSyncInfo';

/**
 * ExportModuleInfo struct
 */
class ExportModuleInfo {
  /**
   * Initialize struct
   * @param {!ExportModuleSyncInfo=} priceSyncInfo
   * @param {!ExportModuleSyncInfo=} dailySyncInfo
   * @param {!ExportModuleSyncInfo=} tradeSyncInfo
   * @param {!ExportModuleSyncInfo=} userSyncInfo
   * @constructor
   */
  constructor (priceSyncInfo = new ExportModuleSyncInfo(), dailySyncInfo = new ExportModuleSyncInfo(), tradeSyncInfo = new ExportModuleSyncInfo(), userSyncInfo = new ExportModuleSyncInfo()) {
    this.PriceSyncInfo = priceSyncInfo
    this.DailySyncInfo = dailySyncInfo
    this.TradeSyncInfo = tradeSyncInfo
    this.UserSyncInfo = userSyncInfo
  }

  /**
   * Copy struct (shallow copy)
   * @this {!ExportModuleInfo}
   * @param {!ExportModuleInfo} other Other struct
   * @returns {!ExportModuleInfo} This struct
   */
  copy (other) {
    if (other.PriceSyncInfo != null) {
      this.PriceSyncInfo = ExportModuleSyncInfo.fromObject(other.PriceSyncInfo)
    } else {
      this.PriceSyncInfo = null
    }
    if (other.DailySyncInfo != null) {
      this.DailySyncInfo = ExportModuleSyncInfo.fromObject(other.DailySyncInfo)
    } else {
      this.DailySyncInfo = null
    }
    if (other.TradeSyncInfo != null) {
      this.TradeSyncInfo = ExportModuleSyncInfo.fromObject(other.TradeSyncInfo)
    } else {
      this.TradeSyncInfo = null
    }
    if (other.UserSyncInfo != null) {
      this.UserSyncInfo = ExportModuleSyncInfo.fromObject(other.UserSyncInfo)
    } else {
      this.UserSyncInfo = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!ExportModuleInfo}
   * @returns {!ExportModuleInfo} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new ExportModuleInfoModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new ExportModuleInfoModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!ExportModuleInfo}
   * @param {!ExportModuleInfo} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ExportModuleInfo)) {
      throw new TypeError('Instance of ExportModuleInfo is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!ExportModuleInfo}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      PriceSyncInfo: ((this.PriceSyncInfo != null) ? this.PriceSyncInfo : null),
      DailySyncInfo: ((this.DailySyncInfo != null) ? this.DailySyncInfo : null),
      TradeSyncInfo: ((this.TradeSyncInfo != null) ? this.TradeSyncInfo : null),
      UserSyncInfo: ((this.UserSyncInfo != null) ? this.UserSyncInfo : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return ExportModuleInfo.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!ExportModuleInfo} other Object value
   * @returns {!ExportModuleInfo} Created struct
   */
  static fromObject (other) {
    return new ExportModuleInfo().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!ExportModuleInfo}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return ExportModuleInfo.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!ExportModuleInfo}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 87
  }
}

export { ExportModuleInfo };

/**
 * Fast Binary Encoding ExportModuleInfo field model
 */
class FieldModelExportModuleInfo extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.PriceSyncInfo = new FieldModelExportModuleSyncInfo(buffer, 4 + 4)
    this.DailySyncInfo = new FieldModelExportModuleSyncInfo(buffer, this.PriceSyncInfo.fbeOffset + this.PriceSyncInfo.fbeSize)
    this.TradeSyncInfo = new FieldModelExportModuleSyncInfo(buffer, this.DailySyncInfo.fbeOffset + this.DailySyncInfo.fbeSize)
    this.UserSyncInfo = new FieldModelExportModuleSyncInfo(buffer, this.TradeSyncInfo.fbeOffset + this.TradeSyncInfo.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelExportModuleInfo}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelExportModuleInfo}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.PriceSyncInfo.fbeSize + this.DailySyncInfo.fbeSize + this.TradeSyncInfo.fbeSize + this.UserSyncInfo.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelExportModuleInfo}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.PriceSyncInfo.fbeExtra + this.DailySyncInfo.fbeExtra + this.TradeSyncInfo.fbeExtra + this.UserSyncInfo.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelExportModuleInfo}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelExportModuleInfo.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelExportModuleInfo}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 87
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelExportModuleInfo}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelExportModuleInfo}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.PriceSyncInfo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.PriceSyncInfo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PriceSyncInfo.fbeSize

    if ((fbeCurrentSize + this.DailySyncInfo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DailySyncInfo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DailySyncInfo.fbeSize

    if ((fbeCurrentSize + this.TradeSyncInfo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TradeSyncInfo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeSyncInfo.fbeSize

    if ((fbeCurrentSize + this.UserSyncInfo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.UserSyncInfo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.UserSyncInfo.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelExportModuleInfo}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelExportModuleInfo}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelExportModuleInfo}
   * @param {!ExportModuleInfo} fbeValue Default value, defaults is new ExportModuleInfo()
   * @returns {!ExportModuleInfo} ExportModuleInfo value
   */
  get (fbeValue = new ExportModuleInfo()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelExportModuleInfo}
   * @param {!ExportModuleInfo} fbeValue ExportModuleInfo value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.PriceSyncInfo.fbeSize) <= fbeStructSize) {
      fbeValue.PriceSyncInfo = this.PriceSyncInfo.get()
    } else {
      fbeValue.PriceSyncInfo = new ExportModuleSyncInfo()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PriceSyncInfo.fbeSize

    if ((fbeCurrentSize + this.DailySyncInfo.fbeSize) <= fbeStructSize) {
      fbeValue.DailySyncInfo = this.DailySyncInfo.get()
    } else {
      fbeValue.DailySyncInfo = new ExportModuleSyncInfo()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DailySyncInfo.fbeSize

    if ((fbeCurrentSize + this.TradeSyncInfo.fbeSize) <= fbeStructSize) {
      fbeValue.TradeSyncInfo = this.TradeSyncInfo.get()
    } else {
      fbeValue.TradeSyncInfo = new ExportModuleSyncInfo()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeSyncInfo.fbeSize

    if ((fbeCurrentSize + this.UserSyncInfo.fbeSize) <= fbeStructSize) {
      fbeValue.UserSyncInfo = this.UserSyncInfo.get()
    } else {
      fbeValue.UserSyncInfo = new ExportModuleSyncInfo()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.UserSyncInfo.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelExportModuleInfo}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelExportModuleInfo}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelExportModuleInfo}
   * @param {!ExportModuleInfo} fbeValue ExportModuleInfo value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelExportModuleInfo}
   * @param {ExportModuleInfo} fbeValue ExportModuleInfo value
   */
  setFields (fbeValue) {
    this.PriceSyncInfo.set(fbeValue.PriceSyncInfo)
    this.DailySyncInfo.set(fbeValue.DailySyncInfo)
    this.TradeSyncInfo.set(fbeValue.TradeSyncInfo)
    this.UserSyncInfo.set(fbeValue.UserSyncInfo)
  }
}

export { FieldModelExportModuleInfo };

/**
 * Fast Binary Encoding ExportModuleInfo model
 */
class ExportModuleInfoModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelExportModuleInfo(this.buffer, 4)
  }

  /**
   * Get the ExportModuleInfo model
   * @this {!ExportModuleInfoModel}
   * @returns {!FieldModelExportModuleInfo} model ExportModuleInfo model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!ExportModuleInfoModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!ExportModuleInfoModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return ExportModuleInfoModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!ExportModuleInfoModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelExportModuleInfo.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!ExportModuleInfoModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!ExportModuleInfoModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!ExportModuleInfoModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!ExportModuleInfoModel}
   * @param {!ExportModuleInfo} value ExportModuleInfo value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!ExportModuleInfoModel}
   * @param {!ExportModuleInfo} value ExportModuleInfo value, defaults is new ExportModuleInfo()
   * @return {!object} Deserialized ExportModuleInfo value and its size
   */
  deserialize (value = new ExportModuleInfo()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new ExportModuleInfo(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new ExportModuleInfo(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!ExportModuleInfoModel}
   * @param {!number} prev Previous ExportModuleInfo model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { ExportModuleInfoModel };
